import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import Step1 from './stepper/step1'
import Step2 from './stepper/step2'
import Step3 from './stepper/step3'
import Step4 from './stepper/step4'
import Step5 from './stepper/step5'
import Step6 from './stepper/step6'
import Step7 from './stepper/step7'
import Step8 from './stepper/step8'
import Step9 from './stepper/step9'
import Step10 from './stepper/step10'
import Grid from '@material-ui/core/Grid';
import Header from './common/headers'


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));

function getSteps() {
  return ['Client Interview Sheet - Auto Accident', 'Employment', 'Automobile Insurance', 'Facts of Accident', 'Independent Witnesses', 
          'Healthcare Rendered', 'Defendant-1', 'Defendant-1 Insurance', 'Additional Defendant\'s Information', 'Any Additional Information'];
}

function getStepContent(step) {
  switch (step) {
    case 0:
      return <Step1/>;
    case 1:
      return <Step2/>;
    case 2:
      return <Step3/>;
    case 3:
      return <Step4/>;

    case 4:
      return <Step5/>;
    case 5:
      return <Step6/>;
    case 6:
      return <Step7/>
    case 7:
      return <Step8/>
    case 8:
      return <Step9/>
    case 9:
      return <Step10/>
    default:
      return 'Unknown step';
  }
}

export default function Form() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
      <div>
      <Header/>
        <Container>
        <div className={classes.root}>
      <form>
      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
            <StepContent>
              <Typography component="div">{getStepContent(index)}</Typography>
              <div className={classes.actionsContainer}>
                <div>
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className={classes.button}
                  >
                    Back
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    className={classes.button}
                  >
                    {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                  </Button>
                </div>
              </div>
            </StepContent>
          </Step>
        ))}
      </Stepper>
      </form>
      {activeStep === steps.length && (
        <Paper square elevation={0} className={classes.resetContainer}>
          <Typography component="div">All steps completed - you&apos;re finished</Typography>
          <Button onClick={handleReset} className={classes.button}>
            Reset
          </Button>
        </Paper>
      )}
    </div>
        </Container>
  </div>
  );
}
